import {awaitForm} from '@/common/http'
import store from '@/store'

export default class WeixinModel {
  static appid = 'wx084c57619586dcdf';
  static expirein = 60*60*1; // 1小时
  // static expirein = 60*1; // 1分钟

  static getUserInfo(code) {
    const ret = awaitForm(`/wx/oauth/${WeixinModel.appid}/greet`, {
      'code': code,
    })
    return ret
  }

  static isTimeout(){
    if(!store.getters.isLogin || Number((store.getters.user['expiresDate']) || -1) < new Date().getTime()/1000-WeixinModel.expirein){
      return true
    } else {
      return false
    }
  }

  static getState(){
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  }

  static getAuthUrl(redirect_uri, state) {
    let scope = 'snsapi_userinfo'
    let ret = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    return ret
  }
  
  static getTest(){
    return `/wx/oauth/${WeixinModel.appid}/greet`
  }
}